import { render, staticRenderFns } from "./ProductSkuAutocompleteBasic.vue?vue&type=template&id=fac2af46"
import script from "./ProductSkuAutocompleteBasic.vue?vue&type=script&lang=ts"
export * from "./ProductSkuAutocompleteBasic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fac2af46')) {
      api.createRecord('fac2af46', component.options)
    } else {
      api.reload('fac2af46', component.options)
    }
    module.hot.accept("./ProductSkuAutocompleteBasic.vue?vue&type=template&id=fac2af46", function () {
      api.rerender('fac2af46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductSkuAutocompleteBasic.vue"
export default component.exports